/* ============================================================
   PUFFY — Opulent Pakistan mascot (original character) · V3 for Shopify
   File: assets/v3-mascot.js — loaded by snippets/v3-mascot.liquid,
   rendered once from layout/theme.liquid so Puffy appears sitewide
   (homepage, product, collection, cart, pages).
   TRULY ANIMATED: real walk cycle + travels with the scroll.
   Vanilla JS, no libraries, no dependencies. Safe on pages
   without shop buttons. Greyscale only (all art is inline SVG).

   SHOPIFY ADAPTATIONS vs the demo mascot.js (art, timings and
   bubble copy are byte-identical to the approved demo):
   - Order-button hooks: the demo classes (.order-btn / .op-order-btn)
     PLUS real Shopify product-form markup —
       [name="add"]                       Add to Cart submit (any theme,
                                          incl. sticky ATC + quick-add,
                                          which reuse the product form)
       .v3p-add-btn                       this port's own ATC button
                                          (sections/v3-product.liquid)
       .product-form__submit              Dawn-style submit class
       form[action*="/cart/add"] submit   any submit inside a cart form
       .shopify-payment-button__button    dynamic checkout / Buy It Now
       [name="checkout"]                  cart-page checkout button
   - Size/variant hooks: the demo classes (.size-btn / .op-size-btn)
     PLUS Shopify variant pickers —
       .v3p-size-btn / [data-v3p-size-btn]  this port's own size buttons
                                          (sections/v3-product.liquid);
                                          its <select name="id"
                                          class="v3p-variant-select"> is
                                          covered by the select hooks
       input[type="radio"][name^="options"]   variant pill/swatch radios
       select[name^="options"], select[name="id"]  variant dropdowns
       pill / swatch <label> elements (clicking a label also fires the
       input, so celebrations are de-duped — see celebrate()).
     Variant <select>s celebrate on `change`, not on the click that
     merely opens the dropdown.
   - A `submit` fallback on /cart/add forms catches order clicks the
     click-delegation could miss (e.g. keyboard submission).
   - All reactions use document-level delegation, so they keep working
     when Dawn/Horizon re-renders the buy section after a variant
     change or an AJAX add-to-cart (no page reload, no re-binding).
   - The animation loop pauses while the tab is hidden.
   - Never calls preventDefault and never touches the form — Puffy
     only observes; Shopify's own add-to-cart flow is untouched.
   ============================================================ */
(function () {
  "use strict";

  var LEG_L =
    '<g class="puffy-leg-left">' +
      '<rect x="71" y="160" width="16" height="20" rx="7" fill="#222"/>' +
      '<ellipse cx="76" cy="186" rx="14" ry="7" fill="#111"/>' +
    '</g>';
  var LEG_R =
    '<g class="puffy-leg-right">' +
      '<rect x="113" y="160" width="16" height="20" rx="7" fill="#222"/>' +
      '<ellipse cx="124" cy="186" rx="14" ry="7" fill="#111"/>' +
    '</g>';

  var SVG =
    '<div class="op-mascot-inner">' +
      '<div class="op-mascot-bubble" role="status" aria-live="polite"></div>' +
      '<div class="op-mascot-zzz" aria-hidden="true"><span>Z</span><span>Z</span><span>Z</span></div>' +
      '<svg class="op-mascot-svg" viewBox="0 0 200 210" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Puffy, the Opulent Pakistan mascot">' +
        /* burst dots (celebrate) */
        '<g class="puffy-burst" aria-hidden="true">' +
          '<circle class="puffy-burst-dot" cx="28" cy="34" r="4.5" fill="#111" style="--bx:-12px;--by:-10px"/>' +
          '<circle class="puffy-burst-dot" cx="58" cy="12" r="3.5" fill="#888" style="--bx:-6px;--by:-16px"/>' +
          '<circle class="puffy-burst-dot" cx="100" cy="4" r="4.5" fill="#111" style="--bx:0px;--by:-18px"/>' +
          '<circle class="puffy-burst-dot" cx="142" cy="12" r="3.5" fill="#888" style="--bx:6px;--by:-16px"/>' +
          '<circle class="puffy-burst-dot" cx="172" cy="34" r="4.5" fill="#111" style="--bx:12px;--by:-10px"/>' +
          '<circle class="puffy-burst-dot" cx="184" cy="84" r="3.5" fill="#888" style="--bx:16px;--by:-4px"/>' +
          '<circle class="puffy-burst-dot" cx="16" cy="84" r="3.5" fill="#888" style="--bx:-16px;--by:-4px"/>' +
          '<circle class="puffy-burst-dot" cx="178" cy="140" r="4" fill="#111" style="--bx:14px;--by:6px"/>' +
        '</g>' +
        /* ground shadow */
        '<ellipse class="puffy-shadow" cx="100" cy="196" rx="46" ry="6" fill="#111" opacity="0.25"/>' +
        /* whole character (flips with travel direction) */
        '<g class="puffy-char">' +
          LEG_L + LEG_R +
          '<g class="puffy-torso">' +
            /* left arm */
            '<g class="puffy-arm-left"><ellipse cx="42" cy="120" rx="11" ry="23" fill="#111" stroke="#fff" stroke-width="2.5" transform="rotate(16 42 120)"/></g>' +
            /* body — the puffer jacket */
            '<ellipse cx="100" cy="120" rx="60" ry="57" fill="#111"/>' +
            /* baffle lines */
            '<path d="M46,102 Q100,114 154,102" fill="none" stroke="#f2f2f2" stroke-width="3" stroke-linecap="round"/>' +
            '<path d="M42,126 Q100,138 158,126" fill="none" stroke="#bdbdbd" stroke-width="3" stroke-linecap="round"/>' +
            '<path d="M49,150 Q100,161 151,150" fill="none" stroke="#f2f2f2" stroke-width="3" stroke-linecap="round"/>' +
            /* centre zipper */
            '<line x1="100" y1="106" x2="100" y2="170" stroke="#fff" stroke-width="3" stroke-linecap="round"/>' +
            '<rect x="96.5" y="118" width="7" height="10" rx="2" fill="#fff"/>' +
            /* right arm (waving / swinging) */
            '<g class="puffy-arm-right"><ellipse cx="158" cy="120" rx="11" ry="23" fill="#111" stroke="#fff" stroke-width="2.5" transform="rotate(-16 158 120)"/></g>' +
            /* face */
            '<circle cx="100" cy="70" r="34" fill="#fff" stroke="#111" stroke-width="4"/>' +
            '<path d="M91,37 Q100,29 109,37" fill="none" stroke="#111" stroke-width="3.5" stroke-linecap="round"/>' +
            '<ellipse cx="73" cy="79" rx="5.5" ry="3.2" fill="#cfcfcf"/>' +
            '<ellipse cx="127" cy="79" rx="5.5" ry="3.2" fill="#cfcfcf"/>' +
            /* eyes — open (blink via CSS) */
            '<g class="puffy-eyes-open"><circle cx="87" cy="66" r="4.6" fill="#111"/><circle cx="113" cy="66" r="4.6" fill="#111"/></g>' +
            /* eyes — closed (sleep) */
            '<g class="puffy-eyes-closed"><path d="M78,66 Q87,72 96,66" fill="none" stroke="#111" stroke-width="3.2" stroke-linecap="round"/><path d="M104,66 Q113,72 122,66" fill="none" stroke="#111" stroke-width="3.2" stroke-linecap="round"/></g>' +
            /* mouth */
            '<path class="puffy-mouth-smile" d="M88,80 Q100,91 112,80" fill="none" stroke="#111" stroke-width="3.5" stroke-linecap="round"/>' +
            '<ellipse class="puffy-mouth-open" cx="100" cy="84" rx="7" ry="9" fill="#111"/>' +
          '</g>' +
        '</g>' +
      '</svg>' +
    '</div>';

  /* Demo hooks kept first; Shopify product-form hooks follow. */
  var ORDER_SEL =
    ".order-btn, .op-order-btn, .v3p-add-btn, " +
    '[name="add"], .product-form__submit, .quick-add__submit, ' +
    'form[action*="/cart/add"] [type="submit"], ' +
    ".shopify-payment-button__button, .shopify-payment-button button, " +
    '[name="checkout"], .cart__checkout-button';
  var SIZE_SEL =
    ".size-btn, .op-size-btn, .v3p-size-btn, [data-v3p-size-btn], " +
    'input[type="radio"][name^="options"], input[type="radio"][name="id"], ' +
    'select[name^="options"], select[name="id"], .v3p-variant-select, ' +
    ".product-form__input--pill label, .product-form__input--swatch label, " +
    "variant-radios label, .swatch-input__label, label[data-variant-value]";
  var SIZE_CHANGE_SEL =
    'input[type="radio"][name^="options"], input[type="radio"][name="id"], ' +
    'select[name^="options"], select[name="id"], .v3p-variant-select';

  function closestMatch(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }
  function isDisabled(el) {
    return !el || el.disabled || el.getAttribute("aria-disabled") === "true" ||
      (el.classList && (el.classList.contains("disabled") || el.classList.contains("sold-out")));
  }

  function init() {
    var host = document.getElementById("puffy-root") || document.getElementById("op-mascot");
    if (!host) {
      host = document.createElement("div");
      host.id = "puffy-root";
      document.body.appendChild(host);
    }
    if (host.getAttribute("data-puffy-init") === "1") return;
    host.setAttribute("data-puffy-init", "1");
    host.innerHTML = SVG;

    var bubble = host.querySelector(".op-mascot-bubble");
    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* ---------- speech bubble ---------- */
    var bubbleTimer = null;
    function showBubble(text, ms) {
      if (!bubble) return;
      bubble.textContent = text;
      bubble.classList.add("is-show");
      if (bubbleTimer) clearTimeout(bubbleTimer);
      if (ms) bubbleTimer = setTimeout(function () { bubble.classList.remove("is-show"); }, ms);
    }
    function hideBubble() {
      if (bubbleTimer) clearTimeout(bubbleTimer);
      if (bubble) bubble.classList.remove("is-show");
    }

    /* ---------- state machine ----------
       Priority: celebrate / wave(greeting) / excited (timed overrides)
       beat the locomotion base state (walking | idle). */
    var override = null, overrideUntil = 0;
    var idleSince = null;
    var currentState = "";
    function setState(name) {
      if (name === currentState) return;
      currentState = name;
      host.setAttribute("data-state", name);
    }
    function setOverride(name, ms) {
      override = name;
      overrideUntil = performance.now() + ms;
    }
    /* De-duped celebrate: a Shopify variant <label> click fires the
       label AND its radio (and a submit click is followed by the form
       submit) — without this guard Puffy would celebrate twice and
       restart his bubble. Same-kind celebrations within 900ms merge. */
    var lastCelebrateAt = 0, lastCelebrateKind = "";
    function celebrate(kind, text, ms) {
      var now = performance.now();
      if (kind === lastCelebrateKind && now - lastCelebrateAt < 900) return;
      lastCelebrateAt = now;
      lastCelebrateKind = kind;
      setOverride("celebrate", ms);
      showBubble(text, ms);
    }
    function celebrateOrder() { celebrate("order", "Shukriya! Your order is on its way", 3200); }
    function celebrateSize() { celebrate("size", "Great pick!", 2200); }

    /* ---------- travel engine ----------
       Puffy's x maps to page scroll progress: 0% → bottom-left,
       100% → bottom-right. He walks (lerp) toward the target;
       facing flips with travel direction. */
    var START_X = 12;
    var curX = START_X, targetX = START_X, dir = 1;
    var lastScrollAt = 0, exciteCooldownUntil = 0, lastExciteCheck = 0;

    function computeTarget() {
      var doc = document.documentElement;
      var maxScroll = Math.max(1, doc.scrollHeight - window.innerHeight);
      var p = Math.min(1, Math.max(0, window.scrollY / maxScroll));
      var hostW = host.offsetWidth || 120;
      var maxX = Math.max(START_X, window.innerWidth - hostW - 12);
      return START_X + p * (maxX - START_X);
    }
    function onScroll() {
      lastScrollAt = performance.now();
      if (!reduced) targetX = computeTarget();
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    window.addEventListener("load", onScroll); /* late images/fonts settle scrollHeight */
    targetX = reduced ? START_X : computeTarget();
    curX = START_X; /* always start bottom-left, then walk to his scroll position */
    host.style.transform = "translateX(" + curX + "px)";

    /* Excitement when Puffy walks into view of an order button */
    function checkOrderProximity(now) {
      if (now - lastExciteCheck < 200 || now < exciteCooldownUntil) return;
      lastExciteCheck = now;
      var btns = document.querySelectorAll(ORDER_SEL);
      var puffyCx = curX + (host.offsetWidth || 120) / 2;
      for (var i = 0; i < btns.length; i++) {
        if (isDisabled(btns[i])) continue;
        var r = btns[i].getBoundingClientRect();
        if (r.width === 0 || r.bottom < 0 || r.top > window.innerHeight) continue;
        var cx = r.left + r.width / 2;
        if (Math.abs(cx - puffyCx) < 210) {
          exciteCooldownUntil = now + 5000;
          setOverride("excited", 1700);
          showBubble("COD — pay at your door!", 1700);
          return;
        }
      }
    }

    var rafId = null;
    function frame(now) {
      /* locomotion */
      var dx = targetX - curX;
      var moving = false;
      if (!reduced && Math.abs(dx) > 1.2) {
        var step = dx * 0.16;
        if (Math.abs(step) < 0.9) step = dx > 0 ? 0.9 : -0.9;
        curX += step;
        dir = dx > 0 ? 1 : -1;
        moving = true;
        host.style.transform = "translateX(" + curX.toFixed(1) + "px)";
        host.setAttribute("data-dir", String(dir));
        if (bubble) bubble.classList.toggle("bubble-left", curX > window.innerWidth * 0.5);
      }
      var scrolling = now - lastScrollAt < 160;
      var isWalking = moving && (scrolling || Math.abs(dx) > 30);

      /* state resolution — celebrate/excited beat walking;
         walking beats the greeting wave (no gliding!);
         the wave shows whenever he is standing still. */
      var active = (override && now < overrideUntil) ? override : null;
      if (!active) override = null;
      /* Idle attract: ~22s continuously idle (not walking, no override)
         fires the wave override for 2.4s, then the idle timer resets. */
      if (active || isWalking || !bootDone) {
        idleSince = null;
      } else {
        if (idleSince === null) idleSince = now;
        if (now - idleSince >= 22000) {
          setOverride("wave", 2400);
          active = "wave";
          idleSince = null;
        }
      }
      if (active === "celebrate" || active === "excited") {
        setState(active);
      } else if (isWalking) {
        setState("walking");
        checkOrderProximity(now);
      } else if (active) {
        setState(active);
      } else {
        setState(bootDone ? "idle" : "sleep");
      }
      rafId = requestAnimationFrame(frame);
    }
    /* Pause the loop in background tabs; resume on return. */
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = null;
      } else if (!rafId) {
        rafId = requestAnimationFrame(frame);
      }
    });

    /* ---------- boot: WAKE → WAVE + GREETING ---------- */
    var bootDone = false;
    setState("sleep");
    setTimeout(function () {
      setOverride("wave", 4500);
      showBubble("Assalam-o-Alaikum! Free delivery on orders over Rs 5,000", 4500);
      setTimeout(function () { bootDone = true; }, 4500);
    }, 1200);
    rafId = requestAnimationFrame(frame);

    /* ---------- reactions (delegated, guarded) ---------- */
    function excite() {
      if (override === "celebrate") return;
      setOverride("excited", 2600);
      showBubble("COD — pay at your door!", 2600);
    }
    document.addEventListener("mouseover", function (e) {
      if (!closestMatch(e.target, ORDER_SEL)) return;
      excite();
    });
    document.addEventListener("focusin", function (e) {
      if (!closestMatch(e.target, ORDER_SEL)) return;
      excite();
    });
    document.addEventListener("mouseout", function (e) {
      var t = closestMatch(e.target, ORDER_SEL);
      if (!t) return;
      if (e.relatedTarget && t.contains(e.relatedTarget)) return;
      if (override === "excited") { override = null; overrideUntil = 0; hideBubble(); }
    });

    /* CELEBRATE — size pick or order click.
       A click on a variant <select> only opens the dropdown, so selects
       are left to the `change` handler below; radios, pill/swatch
       labels and the demo .size-btn buttons celebrate on click. */
    document.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;
      if (host.contains(e.target)) return; /* never react to Puffy himself */
      var orderEl = closestMatch(e.target, ORDER_SEL);
      if (orderEl) {
        if (!isDisabled(orderEl)) celebrateOrder();
        return;
      }
      if (e.target.tagName === "SELECT") return;
      var sizeEl = closestMatch(e.target, SIZE_SEL);
      if (sizeEl && !isDisabled(sizeEl)) celebrateSize();
    });

    /* Variant radios + dropdowns: celebrate the actual pick. */
    document.addEventListener("change", function (e) {
      if (!e.target || !e.target.closest) return;
      if (closestMatch(e.target, SIZE_CHANGE_SEL)) celebrateSize();
    });

    /* Order fallback: a /cart/add form submission Puffy's click
       delegation missed (keyboard submit, JS-triggered submit). */
    document.addEventListener("submit", function (e) {
      var f = e.target;
      if (!f || !f.getAttribute) return;
      var action = f.getAttribute("action") || "";
      if (action.indexOf("/cart/add") !== -1 || f.querySelector('[name="add"]')) {
        celebrateOrder();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
